module.exports = __webpack_public_path__ + "img/stijlen-minimalistic.a39b8219.png";